// `signIn.social({ provider: 'github', callbackURL })` in the Next components. The Rails
// equivalent is the OmniAuth request phase, which is reached through the self-submitting
// page at GET /auth/:provider and returns to `origin` once the session is open.
export function githubSignInPath(callbackPath: string): string {
  return `/auth/github?origin=${encodeURIComponent(callbackPath)}`;
}
